import React from 'react';
import { translate } from 'react-i18next';
import s from './style/_dashboard.scss';
import PropTypes from 'prop-types';

class Dashboard extends React.Component {
  static propTypes = {
    t: PropTypes.func,
  };

  getAppName() {
    const matchInUrl = document.location.href.match(/app=([^&]+)/);
    return (
      (matchInUrl && decodeURIComponent(matchInUrl[1]).replace(/_/g, ' ')) ||
      'Application'
    );
  }

  render() {
    const { t } = this.props;
    const appName = this.getAppName();
    return (
      <div className={s.dashboard}>
        <div className={s.icon} data-other="yes" />

        <h1
          dangerouslySetInnerHTML={{
            __html: t('unavailable.settings.title', { appName }),
          }}
        />

        <div
          className={s['call-to-action']}
          dangerouslySetInnerHTML={{ __html: t('unavailable.settings.market') }}
        />
      </div>
    );
  }
}

export default translate()(Dashboard);
